export default {
  despesaTipoID: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  dataDespesa: {
    value: null,
    maxlength: '10',
    required: true,
    state: null,
    disabled: true
  },
  quantidade: {
    value: 0,
    maxlength: '10',
    required: true,
    state: null,
    disabled: true
  },
  valorUnitario: {
    value: 0,
    maxlength: '20',
    required: true,
    state: null,
    disabled: true
  },
  total: {
    value: 0,
    maxlength: '20',
    required: false,
    state: null,
    disabled: true
  },
  observacao: {
    value: '',
    maxlength: '500',
    required: false,
    rows: '2',
    noResize: true
  }
}



// WEBPACK FOOTER //
// ./src/views/private/finance/expenses/miscellaneous/details/components/modal/credit/modalCredit-form.js